import { AuthService } from "@adc/utilities/auth-service";
import { AuthStatus } from "@adc/utilities/iauthstatusresponse";
import axios from 'axios';
import * as data from "../../assets/header-data.json";
import * as memberData from "../../assets/memberInfoMockData.json";
import { TranslationDataController } from '../utilities/translation-data-controller';
import { GlobalDataController } from "./../utilities/global-data-controller";
import { ContentServiceController } from "./content-service-controller";
import type { GoDarkResponse } from "../utilities/goDark.ts";
import type { IAuthCoBrandResponse } from "@adc/utilities/iauthcobrandresponse";
import type { IAuthUserResponse } from "@adc/utilities/iauthuserresponse";
import type { ReactiveController, ReactiveControllerHost } from "lit";

export class HeaderDataController implements ReactiveController {
  private readonly webContentService: ContentServiceController;
  authService = new AuthService();
  host: ReactiveControllerHost;
  public menuData: any;
  accountDetails: void | IAuthUserResponse;
  authStatus: AuthStatus = AuthStatus.GUEST;
  cobrandMembership = '';
  isDataFetched = false;
  goDarkData: GoDarkResponse;

  constructor(host: ReactiveControllerHost) {
    (this.host = host).addController(this);
    this.webContentService = new ContentServiceController(host, GlobalDataController.getEnvironment());
  }


  hostConnected() {
    this.fetchData();
    if(GlobalDataController._isHomePage()) {
        this.getGoDarkData();
    }
    this.getAccountDetails().then(() => {
      this.host.requestUpdate();
    });
  }

  async fetchData() {
    const baseUrl = document.location.hostname;
    const protocol = document.location.protocol;

    if (baseUrl.includes("localhost") || baseUrl.includes("ideal-succotash")) {
      this.processData(data);
    } else {
      try {
        const response = await TranslationDataController.getTranslationData('header', protocol);
        this.processData(response.data);
        this.host.requestUpdate();
      } catch (error) {
        console.error("Error fetching translation data:", error);
      }
   
    }
  }
  
  getGoDarkData(): void {
    try {
      this.webContentService.fetchData(TranslationDataController.retrieveLocale(), 'fragments/home-page/emergency-response/go-dark.json', 'go-dark', 'JSON').then((response: any) => {
          this.goDarkData = response;
          this.host.requestUpdate();
        })
        .catch((error) => {
          console.error("Error fetching goDarkData:", error);
        });
    } catch (error) {
      console.error("Unexpected error in getGoDarkData:", error);
    }
  }
  

  processData(jsonData) {
    this.menuData = JSON.parse(JSON.stringify(jsonData));
  }

  async getAccountDetails() {
    await this.getAuthStatus().then(() => {
      if (this.authStatus === AuthStatus.SECURED) {
        this.getMemberInformation().then(() => {
          this.getCoBrandMembership();
        });
      }
      this.isDataFetched = true;
    });
  }

  async getMemberInformation() {
    await this.authService.getMemberInformation().then(resp => {
      this.accountDetails = resp;
      this.host.requestUpdate();
    }).catch(err => {
      console.log("Loyalty api error", err);
    });
  }

  async getCoBrandMembership() {
    await axios.get<IAuthCoBrandResponse>('/loyalty/api/membership').then(resp => {
      if(this.accountDetails){
        this.accountDetails.cobrandMembership = resp.data.value;
      }
      this.host.requestUpdate();
    }).catch(err => {
      console.log("Loyalty api error", err);
    });
  }

  async getAuthStatus() {
    const urlParamValue = TranslationDataController.getURLParam();
    await this.authService.getAuthStatus(urlParamValue).then(resp => {
      this.authStatus = resp.status;
    }).catch(err => {
      const url = new URL(document.location.href);
      const allowedAADomains = [
        'www.aa.com',
        'iqa.qa.aa.com',
        'iqa2.qa.aa.com',
        'stage.aa.com'
      ];

      if (allowedAADomains.includes(url.hostname) || url.hostname.endsWith('.aa.com') || url.hostname.includes('american')) {
        this.authStatus = AuthStatus.GUEST;
      } else {
        this.accountDetails = JSON.parse(JSON.stringify(memberData));
      }

      console.log('authStatus error, ', err);
    });
  }

}
